import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Grid
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useParams, useNavigate, Link } from 'react-router-dom';

export function KitViewComponent() {
  const classes = useStyles();
  const { deviceId } = useParams();
  const navigate = useNavigate();

  const [graphRangeType, setGraphRangeType] = useState(0);
  const [currentGraphRangeType, setCurrentGraphRangeType] = useState(0);
//   const [dateRange, setDateRange] = useState([dayjs().subtract(7, 'day'), dayjs()]);
  const [showForm, setShowForm] = useState(false);
  const [devices, setDevices] = useState([]);
  const [device, setDevice] = useState(null);

  useEffect(() => {
    // Fetch device and kit data here
    setDevice({
      id: deviceId,
      devices: ['DeviceA', 'DeviceB'],
      createdBy: { lastName: 'Admin' },
      modifiedBy: { lastName: 'Editor' },
    });
  }, [deviceId]);

  const handleLoadGraph = () => {
    setCurrentGraphRangeType(graphRangeType);
    // Trigger graph update
  };

  const handleEditKit = () => {
    setShowForm(true);
  };

  return (
    <Box className={classes.container}>
      <Typography variant="h5" className={classes.title}>Graph</Typography>
      <Container>
        <Box className={classes.topBar}>
          <Button variant="outlined" onClick={handleEditKit}>
            Edit Kit
          </Button>
        </Box>

        {/* <GraphComparable
          properties={device?.kit?.properties || []}
          xPointsCount={8}
          graphDataObservable={{}}
        /> */}

        <Box className={classes.radioGroup}>
          <RadioGroup row value={graphRangeType} onChange={e => setGraphRangeType(parseInt(e.target.value))}>
            <FormControlLabel value={0} control={<Radio />} label="Today" />
            <FormControlLabel value={1} control={<Radio />} label="Last Week" />
            <FormControlLabel value={2} control={<Radio />} label="Last Month" />
            <FormControlLabel value={3} control={<Radio />} label="Custom" />
          </RadioGroup>
        </Box>

        {graphRangeType === 3 && (
          <Box className={classes.datePicker}>
            {/* <DateRangePicker
              value={dateRange}
              onChange={(newValue) => {
                setDateRange(newValue);
                setCurrentGraphRangeType(null);
              }}
              localeText={{ start: 'From', end: 'To' }}
            /> */}
          </Box>
        )}

        <Box className={classes.loadButton}>
          <Button
            variant="contained"
            onClick={handleLoadGraph}
            disabled={currentGraphRangeType === graphRangeType}
          >
            Load Graph
          </Button>
        </Box>

        <Paper className={classes.tablePaper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Connected Devices</TableCell>
                <TableCell>Kit Created By</TableCell>
                <TableCell>Kit Modified By</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {device.devices.map(dev => (
                <TableRow key={dev}>
                  <TableCell>{dev}</TableCell>
                  <TableCell>{device.createdBy.lastName}</TableCell>
                  <TableCell>{device.modifiedBy.lastName}</TableCell>
                  <TableCell>
                    <Button
                      component={Link}
                      to={`/device/${dev}`}
                      variant="outlined"
                      size="small"
                      className={classes.actionButton}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Container>

      {/* {showForm && (
        <KitForm
          kit={device?.kit}
          formType="EDIT"
          onClose={() => setShowForm(false)}
          onRefresh={() => {}}
        />
      )} */}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
    container: {
      width: '100%',
    },
    title: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
    },
    topBar: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: theme.spacing(2),
    },
    graphSection: {
      marginTop: theme.spacing(3),
    },
    radioGroup: {
      marginTop: theme.spacing(3),
    },
    datePicker: {
      marginTop: theme.spacing(2),
    },
    loadButton: {
      marginTop: theme.spacing(2),
    },
    tablePaper: {
      marginTop: theme.spacing(4),
      overflowX: 'auto',
    },
    actionButton: {
      textTransform: 'none',
    },
  }));